import { render, staticRenderFns } from "./newbuffer.vue?vue&type=template&id=4a6878cb&scoped=true&"
import script from "./newbuffer.vue?vue&type=script&lang=js&"
export * from "./newbuffer.vue?vue&type=script&lang=js&"
import style0 from "./newbuffer.vue?vue&type=style&index=0&id=4a6878cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6878cb",
  null
  
)

export default component.exports